import { AppModal } from '@/components/AppModal'

interface SuccessModalProps {
  show: boolean
  message: string
  onClose: () => void
}

export const SuccessModal = ({ show, message, onClose }: SuccessModalProps) => {
  return (
    <AppModal isOpen={show} onClose={onClose} maxWidth={500}>
      <div className="app-modal__center success-modal__content">
        <div className="success-modal__icon">
          <i className="bi bi-check-circle-fill success-modal__icon-check"></i>
        </div>
        <h3 className="success-modal__title">仮登録申請を受け付けました</h3>
        <p className="success-modal__message">{message}</p>
      </div>
      <div className="app-modal__actions success-modal__actions">
        <button type="button" onClick={onClose} className="editable-field-button">
          閉じる
        </button>
      </div>
    </AppModal>
  )
}

